import { Trans } from 'react-i18next';

import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { EventConfirmIcon } from '@dreryk/react-components';
import { dateFormatter, hourMinuteFormatter } from '@dreryk/react-common';

import { calendarTranslationKeys } from '../../../../../../translations';
import { AppointmentDetailsInfoItem } from '../AppointmentDetailsInfoItem';
import { getPractitionerName } from '../useAppointmentDetailsFluidTab.utils';

const t = calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab;

type AppointmentCreatedByInfoItemProps = {
   creationDate: Date;
   createdBy: AppointmentPractitioner | undefined;
};

export const AppointmentCreatedByInfoItem = (props: AppointmentCreatedByInfoItemProps): JSX.Element | null => {
   if (!props.createdBy) {
      return null;
   }

   const creationDate = dateFormatter(props.creationDate);
   const creationTime = hourMinuteFormatter(props.creationDate);

   return (
      <AppointmentDetailsInfoItem
         testId={'createdBy'}
         content={getPractitionerName(props.createdBy)}
         description={
            <Trans
               i18nKey={t.bookingPersonWithDate}
               values={{ creationDate: creationDate, creationTime: creationTime }}
            />
         }
         icon={<EventConfirmIcon />}
      />
   );
};
